import { Button, Card, Form, Modal } from "react-bootstrap";
import { ProjectFourthStage } from "../../models/project-fourth-stage";
import * as ProjectFourthStageApi from "../../network/project-fourth-stages-api";
import styles from "../../styles/ChangeStageDialog.module.css";
import { useState } from "react";
import { useForm } from "react-hook-form";
import * as NotificationsApi from "../../network/notifications-api";
import * as ProjectsApi from "../../network/projects-api";

interface ChangeFourthStageDialogProps {
    stage: ProjectFourthStage,
    onDismiss: () => void,
    onStageSaved: (stage: ProjectFourthStage) => void,
}

const ChangeFourthStateDialog = ({stage, onDismiss, onStageSaved}: ChangeFourthStageDialogProps) => {
    const [currentStage, setCurrentStage] = useState<ProjectFourthStage>(stage);
    const [newStatus, setNewStatus] = useState("");
    const [showChangeStatusDialog, setShowChangeStatusDialog] = useState(false);

    const downloadFile = () => {
        ProjectFourthStageApi.fetchProjectFourthStageFile({projectId: currentStage.projectId});
    }

    const setStageStatusToDone = async () => {
        const updatedStage = await ProjectFourthStageApi.updateProjectFourthStageStatus({status: "Done"}, currentStage.projectId);
        const projectData = await ProjectsApi.fetchProject({role: "administrator", projectId: stage.projectId});
        if (projectData) {
            const notification = {
                administratorId: projectData.administratorId, 
                type: "23",
                projectId: projectData._id,
                teacherCuratorId: projectData.teacherCuratorId,
                univerObserverCuratorId: projectData.univerObserverCuratorId,
                roivObserverCuratorId: projectData.roivObserverCuratorId,
                regionObserverCuratorId: projectData.regionObserverCuratorId,
            }
            await NotificationsApi.createNotification(notification);
        }
        setCurrentStage(updatedStage);
        onStageSaved(updatedStage);
    }

    interface changeStatusFormProps{
        projectId: string,
        text: string,
        file: File[],
    }
    const { register, handleSubmit, formState : {errors, isSubmitting} } = useForm<changeStatusFormProps>({
        defaultValues: {
            projectId: stage.projectId,
            text: "",
        }
    });

    async function onSubmit(input:changeStatusFormProps) {
        try {
            const updatedStage = await ProjectFourthStageApi.postProjectFourthStage({projectId: input.projectId, status: newStatus, text: input.text, file: input.file[0]});
            const projectData = await ProjectsApi.fetchProject({role: "administrator", projectId: stage.projectId});
            if (projectData) {
                const notification = {
                    administratorId: projectData.administratorId, 
                    type: "22",
                    projectId: projectData._id,
                    teacherCuratorId: projectData.teacherCuratorId,
                    univerObserverCuratorId: projectData.univerObserverCuratorId,
                    roivObserverCuratorId: projectData.roivObserverCuratorId,
                    regionObserverCuratorId: projectData.regionObserverCuratorId,
                }
                await NotificationsApi.createNotification(notification);
            }
            setCurrentStage(updatedStage);
            onStageSaved(updatedStage);
        } catch (error) {
            console.error(error);
            alert(error);
        } finally {
            setShowChangeStatusDialog(false);
        }
    }
    
    return(
        <Modal show onHide={onDismiss}>
            <Modal.Header closeButton>
                <Modal.Title>
                    Этап 4
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Card className={`mb-3 ${styles.descriptionField}`}>
                    <Card.Header>
                        Описание
                    </Card.Header>
                    <Card.Body>
                        {currentStage.text}
                    </Card.Body>
                </Card>
                <Button onClick={downloadFile} className={styles.downloadFileButton}>
                    Скачать закреплённый документ
                </Button>
            </Modal.Body>
            {currentStage.status === "NeedCheck" && !showChangeStatusDialog &&
                <Modal.Footer className={styles.stageFooter}>
                    <Button onClick={() => {setNewStatus("NeedRework"); setShowChangeStatusDialog(true);}} variant="danger" className="mb-3">
                        Отправить на доработку
                    </Button>
                    <Button onClick={() => {setStageStatusToDone()}} variant="success" className="mb-3">
                        Подтвердить
                    </Button>
                </Modal.Footer>
            }
            { showChangeStatusDialog &&
                <Modal.Footer className={styles.stageFooter}>
                    <Form id="changeFourthStageStatus" className="mb-3" onSubmit={handleSubmit(onSubmit)}>
                        <h1>Отправка на доработку</h1>
                        <Form.Group className="mb-3" controlId="text-input">
                            <Form.Label>Описание</Form.Label>
                            <Form.Control 
                                as="textarea" 
                                rows={3} 
                                placeholder="Описание"
                                {...register("text")} 
                                isInvalid={!!errors.text}
                            />
                        </Form.Group>
                        <Form.Group controlId="file-input">
                            <Form.Label>
                                Файл
                            </Form.Label>
                            <Form.Control 
                                type="file"
                                multiple={false}
                                {...register("file")} 
                                isInvalid={!!errors.file}
                            />
                        </Form.Group>
                    </Form>
                    <Button 
                    type="submit"
                    form="changeFourthStageStatus"
                    disabled={isSubmitting}>
                        Отправить
                    </Button>
                </Modal.Footer>
            }
        </Modal>
    );
}

export default ChangeFourthStateDialog;